MinimogTheme.pubSubEvents = {
  cartError: "cart-error",
  cartUpdate: "cart-update",
  openCartDrawer: "open-cart-drawer",
  openSearchPopup: "open-search-popup",
  closeSearchPopup: "close-search-popup",
  optionValueSelectionChange: "option-value-selection-change",
  variantChange: "variant-change",
  quantityUpdate: "quantity-update",
  quantityRules: "quantity-rules",
  quantityBoundries: "quantity-boundries",
};
const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};

MinimogTheme.config = Object.assign({
  mqlMobile: false,
  mqlTablet: false,
  mediaQueryMobile: "screen and (max-width: 767px)",
  mediaQueryTablet: "screen and (max-width: 1023px)",
}, MinimogTheme.config || {});

MinimogTheme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  if (!options.element) return;
  if (typeof IntersectionObserver !== 'function') {
    options.callback?.();
    return;
  }
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};
(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
  MinimogTheme.config.mqlMobile = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      MinimogTheme.config.mqlMobile = true;
      document.dispatchEvent(new CustomEvent("matchMobile"));
    } else {
      MinimogTheme.config.mqlMobile = false;
      document.dispatchEvent(new CustomEvent("unmatchMobile"));
    }
  };

  // Tablet
  const mqltl = window.matchMedia(MinimogTheme.config.mediaQueryTablet);
  MinimogTheme.config.mqlTablet = mqltl.matches;
  mqltl.onchange = (e) => {
    if (e.matches) {
      MinimogTheme.config.mqlTablet = true;
      document.dispatchEvent(new CustomEvent("matchTablet"));
    } else {
      MinimogTheme.config.mqlTablet = false;
      document.dispatchEvent(new CustomEvent("unmatchTablet"));
    }
  };

  // Page transition
  var fader = document.querySelector(".m-page-transition");
  function __fadeInPage() {
    if (!window.AnimationEvent || !fader) return;

    let ignore_beforeunload = false;

    const loadingDesignMode = fader.dataset.designMode === "true";

    document.querySelectorAll("a[href^=mailto], a[href^=tel]").forEach((link) => {
      link.addEventListener("click", () => {
        ignore_beforeunload = true;
      });
    });

    if (loadingDesignMode && Shopify.designMode) {
      fader.classList.add("m-page-transition--design-mode");
    } else {
      // Page transition
      window.addEventListener("beforeunload", () => {
        if (!ignore_beforeunload) fader.classList.add("fade-in");
      });
      window.addEventListener("DOMContentLoaded", () => {
        document.documentElement.classList.remove("m:overflow-hidden");
        document.body.classList.remove("m:overflow-hidden");
        setScrollbarWidth();

        // fader.classList.remove('fade-in')
        setTimeout(() => {
          fader.classList.add("fade-out");
        }, 300);

        document.dispatchEvent(new CustomEvent("page:loaded"));
      });
      window.addEventListener("pageshow", (event) => {
        // Removes unload class when returning to page via history
        if (event.persisted) {
          fader.classList.remove("fade-in");
          // fader.classList.add('fade-out');
        }
      });
    }
  }
  __fadeInPage();
})();

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    if (!oldNode || !newContent) return;
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute("form", `${element.form.getAttribute("id")}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
class CountdownTimer {
  constructor(container, startTime, endTime, options = {}) {
    this.times = ["day", "hour", "min", "sec"];
    this.selectors = {
      day: ".countdown-timer-day",
      hour: ".countdown-timer-hour",
      min: ".countdown-timer-minute",
      sec: ".countdown-timer-sec",
    };
    this.MS_IN_SEC = 1000;
    this.MS_IN_MIN = 60 * this.MS_IN_SEC;
    this.MS_IN_HRS = 60 * this.MS_IN_MIN;
    this.MS_IN_DAY = 24 * this.MS_IN_HRS;

    this.container = container;
    this.startTime = startTime;
    this.savedStartTime = startTime;
    this.endTime = endTime;
    this.options = Object.assign(
      {},
      {
        type: "evergreen",
        duration: "every_month",
        addZeroPrefix: true,
        loop: false,
        callback: () => {},
      },
      options
    );

    this.intervalTime = 1000;
    this.timer = null;
    this.domNodes = queryDomNodes(this.selectors, container);

    this.init();
  }

  init() {
    switch (this.options.type) {
      case "evergreen":
        this.targetTime = this.getEvergreenDueDate().getTime();
        break;
      default:
        this.targetTime = new Date(this.endTime).getTime();
        break;
    }

    this.start();
  }

  start() {
    this.timer = setInterval(() => {
      if (this.startTime > this.targetTime) this.stop();
      else this.update();
    }, this.intervalTime);

    this.container.style.removeProperty("opacity");
  }

  update() {
    const timeData = this.format(this.targetTime - this.startTime);
    this.times.forEach((time) => {
      if (this.domNodes[time]) {
        this.domNodes[time].textContent = this.addZeroPrefix(timeData[time]);
      }
    });
    this.startTime += this.intervalTime;
  }

  stop() {
    clearInterval(this.timer);
    if (this.options.loop) {
      this.startTime = this.savedStartTime;
      this.start();
    } else {
      this.timer = null;
      this.options.callback();
    }
  }

  clear() {
    clearInterval(this.timer);
    this.timer = null;
    this.startTime = this.savedStartTime;
    this.times.forEach((time) => {
      if (this.domNodes[time]) {
        this.domNodes[time].textContent = "00";
      }
    });
  }

  addZeroPrefix(num) {
    if (this.options.addZeroPrefix && num < 10) {
      return `0${num}`;
    }
    return num.toString();
  }

  format(ms) {
    return {
      day: Math.floor(ms / this.MS_IN_DAY),
      hour: Math.floor((ms % this.MS_IN_DAY) / this.MS_IN_HRS),
      min: Math.floor((ms % this.MS_IN_HRS) / this.MS_IN_MIN),
      sec: Math.floor((ms % this.MS_IN_MIN) / this.MS_IN_SEC),
    };
  }

  getEvergreenDueDate() {
    let intervalHrs;
    const now = new Date();
    const dueDate = new Date(now);

    if (Number.isFinite(this.options.duration)) {
      /**
       * Duration is in hours. Convert to milliseconds.
       * Integrate with Foxkit Flash Sale Countdown.
       */
      const durationMs = this.options.duration * 60 * 60 * 1000;
      dueDate.setTime(now.getTime() + durationMs);
      return dueDate;
    } else {
      switch (this.options.duration) {
        case "every_month":
          dueDate.setMonth(dueDate.getMonth() + 1); // Next month.
          dueDate.setDate(1); // Start from the 1st day of the next month.
          dueDate.setHours(0, 0, 0, 0);
          return dueDate;
        case "every_week":
          // eslint-disable-next-line no-case-declarations
          const dayOfWeek = now.getDay(); // Sunday - Saturday : 0 - 6
          // eslint-disable-next-line no-case-declarations
          const daysUntilNextWeek = 7 - dayOfWeek;
          dueDate.setDate(now.getDate() + daysUntilNextWeek); // Move to next Sunday.
          dueDate.setHours(0, 0, 0, 0); // Set the time to 00:00:00.
          return dueDate;
        case "every_2_hrs":
          intervalHrs = 2;
          break;
        case "every_6_hrs":
          intervalHrs = 6;
          break;
        case "every_12_hrs":
          intervalHrs = 12;
          break;
        case "every_day":
          intervalHrs = 24;
          break;
      }
    }

    const currentHour = now.getHours();

    // Possible start points based on the interval.
    const startPoints = [];
    for (let i = 0; i < 24; i += intervalHrs) {
      startPoints.push(i);
    }

    // Find the next start point.
    for (let i = 0; i < startPoints.length; i++) {
      if (
        currentHour < startPoints[i] ||
        (currentHour === startPoints[i] && now.getMinutes() === 0 && now.getSeconds() === 0)
      ) {
        dueDate.setHours(startPoints[i], 0, 0, 0);
        return dueDate;
      }
    }

    // If no future point today, roll over to the first point tomorrow.
    dueDate.setDate(dueDate.getDate() + 1);
    dueDate.setHours(startPoints[0], 0, 0, 0);
    return dueDate;
  }
}
window.MinimogTheme.CountdownTimer = CountdownTimer;

class Tabs {
  constructor(container, cb = () => {}) {
    this.selectors = {
      tabHeaders: [".m-tab-header"],
      tabContents: [".m-tab-content"],
    };
    this.activeClass = "active";
    this.currentActiveIndex = -1;
    this.currentTab = null;
    this.container = container;
    this.cb = cb;
    this.domNodes = queryDomNodes(this.selectors, container);
    this.customSelect = this.container.querySelector("m-select-component");

    this.init();
    this.setActiveTab(0);
  }

  init() {
    addEventDelegate({
      context: this.container,
      selector: this.selectors.tabHeaders[0],
      handler: (e, tabHeader) => {
        e.preventDefault();
        let index;
        if (tabHeader) {
          index = Number(tabHeader.dataset.index);
        }
        this.setActiveTab(index);
        this.cb(tabHeader);
      },
    });
  }

  setActiveTab(tabIndex) {
    const { tabHeaders, tabContents } = this.domNodes;

    if (tabContents.length && tabIndex !== -1 && this.currentActiveIndex !== tabIndex) {
      let currHeader, newHeader, newTab;

      currHeader = tabHeaders && tabHeaders[this.currentActiveIndex];
      newHeader = tabHeaders && tabHeaders[tabIndex];

      if (this.customSelect && newHeader) {
        const tabHeaderStyle = this.customSelect.dataset.tabHeader;
        tabHeaderStyle === "select" && this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML);
        if (MinimogTheme.config.mqlMobile) {
          this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML);
        }
        document.addEventListener("matchMobile", () =>
          this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML)
        );
      }

      newTab = tabContents && tabContents[tabIndex];

      currHeader && currHeader.classList.remove(this.activeClass);
      this.currentTab && this.currentTab.classList.remove(this.activeClass);

      newHeader && newHeader.classList.add(this.activeClass);
      newTab && newTab.classList.add(this.activeClass);
      setTimeout(() => (newTab.style.opacity = 1));

      this.currentActiveIndex = tabIndex;
      this.currentTab = newTab;
    }
  }
}
window.MinimogTheme.Tabs = Tabs;

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    if (!this.countryEl) return;
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    if (!this.provinceEl) return;
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    if (!this.countryEl || !this.countryEl.options) return;
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    if (!opt) return;
    var raw = opt.getAttribute("data-provinces");
    var provinces = raw ? JSON.parse(raw) : [];

    if (this.provinceEl) {
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        if (this.provinceContainer) this.provinceContainer.style.display = "none";
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement("option");
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }

        if (this.provinceContainer) this.provinceContainer.style.display = "";
      }
    }
  },

  clearOptions: function (selector) {
    if (!selector) return;
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

function setScrollbarWidth() {
  document.documentElement.style.setProperty(
    "--m-scrollbar-width",
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );
}

setScrollbarWidth();

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = "minimog:check";
  let storage;
  try {
    if (type === "session") storage = window.sessionStorage;
    if (type === "local") storage = window.localStorage;
    if (!storage) return false;
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getRequestDefaultConfigs() {
  return JSON.parse(JSON.stringify(requestDefaultConfigs));
}

function fetchJSON(url, config = getRequestDefaultConfigs()) {
  return fetch(url, config).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

const cache = new Map();
function fetchCache(url, config = getRequestDefaultConfigs()) {
  if (cache.has(url)) return cache.get(url);
  const pending = fetch(url, config)
    .then((response) => {
      if (!response.ok) throw new Error(`Failed to load: ${url}`);
      return response.text();
    })
    .catch((error) => { cache.delete(url); throw error; });
  cache.set(url, pending);
  return pending;
}

const sectionCache = new Map();
function fetchSection(sectionId, options = {}) {
  const { url: _url, fromCache = false, params = {} } = options;

  const url = new URL(_url || window.location.href);
  url.searchParams.set("section_id", sectionId);
  Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

  // Keyed by string (a URL object never matched) and holding HTML, not DOM: callers move
  // nodes out of the returned tree, so a cached tree would come back emptied. The request
  // itself is cached, so a prefetch and the click that follows it share one download.
  const cacheKey = url.toString();
  let html = fromCache ? sectionCache.get(cacheKey) : undefined;
  if (!html) {
    html = fetch(url, getRequestDefaultConfigs()).then((res) => {
      if (!res.ok) throw new Error(`Failed to load section: ${sectionId}`);
      return res.text();
    });
    if (fromCache) {
      sectionCache.set(cacheKey, html);
      html.catch(() => sectionCache.delete(cacheKey));
      if (sectionCache.size > 20) sectionCache.delete(sectionCache.keys().next().value);
    }
  }
  return html.then(generateDomFromString);
}

const cache2 = new Map();
function fetchJsonCache(url, config = requestDefaultConfigs) {
  if (cache2.has(url)) return cache2.get(url);
  const pending = fetch(url, config)
    .then((response) => {
      if (!response.ok) throw new Error(`Failed to load: ${url}`);
      return response.json();
    })
    .catch((error) => { cache2.delete(url); throw error; });
  cache2.set(url, pending);
  return pending;
}

function formatMoney(cents, format) {
  const moneyFormat = "${{amount}}";
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function validateForm(form) {
  const missingFields = [];
  if (!form) return missingFields;
  const fieldSelectors = '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
  const requiredFields = form.querySelectorAll(fieldSelectors);
  requiredFields.forEach((field) => {
    field.classList.remove("form-control--warning");
    if (field.type === "radio") {
      const buttons = form.querySelectorAll(`input[name="${field.name}"]`);
      const selected = Array.from(buttons).some((btn) => btn.checked);
      if (!selected) {
        missingFields.push(field);
        field.classList.add("form-control--warning");
      }
    } else if (!field.value) {
      missingFields.push(field);
      field.classList.add("form-control--warning");
    }
  });
  return missingFields;
}

function generateDomFromString(value, tagName = "div") {
  const d = document.createElement(tagName);
  d.innerHTML = value;
  return d;
}

function generateDomeFromStringNew(value, selector = "div") {
  const dom = new DOMParser().parseFromString(value, "text/html");
  const newDom = dom.querySelector(selector);
  return newDom;
}

function fetchCountDown(collectionID) {
  const appURL = MinimogSettings.foxKitBaseUrl ? `https://${MinimogSettings.foxKitBaseUrl}` : "";

  return new Promise((resolve, reject) => {
    let requestUrl = `${appURL}/api/public/countdown?shop=${window.Shopify.shop}&collectionIds=${collectionID}`;

    fetch(requestUrl)
      .then((response) => response.json())
      .then(resolve)
      .catch(reject);
  });
}

function loadAssetsNew(files = [], id, callback = () => {}, options = {}) {
  if (typeof window.MinimogLibs?.loadjs !== 'function') return;
  const unique = id ? id : Math.random().toString(36).slice(2);
  if (!window.MinimogLibs.loadjs.isDefined(id)) window.MinimogLibs.loadjs(files, unique);
  window.MinimogLibs.loadjs.ready(unique, callback);
}

function pauseAllMedia(container = document) {
  container.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow?.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  container.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow?.postMessage('{"method":"pause"}', "*");
  });
  container.querySelectorAll("video").forEach((video) => video.pause());
  container.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function loadJS(src, target = document.body, async = false, defer = true) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currScript = doc.querySelector(`script[src="${src}"]`);
    if (currScript) {
      if (currScript.dataset.loaded) return resolve(true);
      currScript.addEventListener("load", () => {
        currScript.dataset.loaded = true;
        resolve(true);
      }, { once: true });
      currScript.addEventListener("error", reject, { once: true });
      return;
    }
    const script = doc.createElement("script");
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.addEventListener("load", () => {
      script.dataset.loaded = true;
      resolve(true);
    });
    script.onerror = reject;
    target.appendChild(script);
  });
}

function loadCSS(href, target = document.head) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currLink = doc.querySelector(`link[href="${href}"]`);
    if (currLink) {
      if (currLink.dataset.loaded) return resolve(true);
      if (currLink.sheet) return resolve(true);
      currLink.addEventListener("load", () => {
        currLink.dataset.loaded = true;
        resolve(true);
      }, { once: true });
      currLink.addEventListener("error", reject, { once: true });
      return;
    }
    const link = doc.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.addEventListener("load", () => {
      link.dataset.loaded = true;
      resolve(true);
    });
    link.onerror = reject;
    target.appendChild(link);
  });
}

function addEventDelegate({ context = document.documentElement, event = "click", selector, handler, capture = false }) {
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (let target = e.target; target && target !== this; target = target.parentNode) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
}
window.addEventDelegate = window.addEventDelegate || addEventDelegate;

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
window.debounce = window.debounce || debounce;

function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === "object") {
    throw new Error(options + "is not a valid array of options.");
  }
}

function _validateProductStructure(product) {
  if (typeof product !== "object") {
    throw new TypeError(product + " is not an object.");
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + " is empty.");
  }
}

function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);
  var result = product.variants.filter(function (variant) {
    return options.every(function (option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === "master") {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|webp|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + "_" + size + suffix);
  } else {
    return null;
  }
}

function removeProtocol(path) {
  return path.replace(/http(s)?:/, "");
}

function updateParam(key, value) {
  var { location } = window;
  var baseUrl = [location.protocol, "//", location.host, location.pathname].join("");

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if (urlParams.has(key)) {
    if (value !== "" && value !== "undefined") {
      urlParams.set(key, value);
    }
    if (value === "" || value === "undefined") {
      urlParams.delete(key);
    }
  } else {
    if (value) urlParams.append(key, value);
  }

  window.history.replaceState({}, "", baseUrl + "?" + urlParams.toString());
  return false;
}

function createSearchLink(query) {
  const searchParams = new URLSearchParams({
    type: "product",
    ["options[unavailable_products]"]: "last",
    ["options[prefix]"]: "last",
    q: query,
  });

  const searchURL = window.MinimogSettings.routes.search_url;
  return `${searchURL}?${searchParams.toString()}`;
}

function refreshProductReview() {
  if (typeof SMARTIFYAPPS !== "undefined" && SMARTIFYAPPS.rv.installed) {
    SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();
  }
  if (typeof Yotpo !== "undefined" && typeof Yotpo.API === "function") {
    const yotpoApi = new Yotpo.API(yotpo);
    yotpoApi?.refreshWidgets();
  }
}

// SetPopularSearchLink
(function () {
  const popularSearchItems = document.querySelectorAll("[data-ps-item]");
  if (popularSearchItems) {
    popularSearchItems.forEach((itm) => (itm.href = createSearchLink(itm.dataset.psQuery)));
  }
})();

function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    if (context) {
      acc[name] = context[queryMethod](sl);
    }
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

function saleProgress(settings, productId, soldNumber) {
  const { total_quantity, sold_to, sold_from } = settings;
  let soldNumb;
  // const hour = new Date().getHours()
  if (soldNumber) {
    soldNumb = parseInt(soldNumber);
  } else {
    const hour = 4;
    const range = sold_to - sold_from;
    const timeRatio = hour / 24;
    const randomRatioById = (Number(productId.split("").pop()) + 1) / 10;
    let combinedRatio = timeRatio + randomRatioById;
    if (combinedRatio > 1) combinedRatio -= 1;

    const delta = Math.ceil(combinedRatio * range);
    soldNumb = sold_from + delta;
  }

  const availableNumb = total_quantity - soldNumb;
  const progress = (soldNumb * 100) / total_quantity;

  return `
    <div class="m-product-sale-progress">
      <div class="m-product-sale-progress__bar" data-flash-sale>
        <span data-sale-progress style="width: ${progress}%;" />
      </div>
      <div class="m-product-sale-progress__text">
        <div>
          <span>${MinimogStrings.sold}: </span>
          <strong data-sale-number>${soldNumb || 0}</strong>
        </div>
        <div>
          <span>${MinimogStrings.available}: </span>
          <strong data-available-number>${availableNumb || 0}</strong>
        </div>
      </div>
    </div>
  `;
}

function spinner(className = "") {
  return `<svg class="animate-spin m:hidden m-svg-icon--medium ${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>`;
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
window.setCookie = window.setCookie || setCookie;

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = document.cookie;
  // One malformed third-party cookie (a raw "%") must not make every read throw URIError.
  try {
    decodedCookie = decodeURIComponent(decodedCookie);
  } catch (_) {}
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
window.getCookie = window.getCookie || getCookie;

function formatUrl(pageType, handle, query) {
  let url;
  const { routes } = MinimogSettings;
  const root = routes.root.endsWith("/") ? "" : routes.root;
  url = `${root}/${pageType}/${handle}`;
  if (query) url += `?${query}`;
  return url;
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id*="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      const templateContent = this.querySelector("template")?.content?.firstElementChild;
      if (!templateContent) return;
      content.appendChild(templateContent.cloneNode(true));

      this.setAttribute("loaded", true);
      const media = content.querySelector("video, model-viewer, iframe");
      if (!media) return;
      const deferredElement = this.appendChild(media);
      this.deferredElement = deferredElement;

      if (focus) deferredElement.focus();
      this.playVideo(deferredElement);
    }
  }

  playVideo(videoElm) {
    if (this.autoPlay) return;

    if (videoElm.classList.contains("js-youtube")) {
      const symbol = videoElm.src.indexOf("?") > -1 ? "&" : "?";
      videoElm.src += symbol + "autoplay=1&mute=1";
    } else if (videoElm.classList.contains("js-vimeo")) {
      const symbol = videoElm.src.indexOf("?") > -1 ? "&" : "?";
      videoElm.src += symbol + "autoplay=1&muted=1";
    } else {
      videoElm && videoElm.setAttribute("autoplay", "autoplay");
      videoElm?.play?.()?.catch?.(() => {});
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class ResponsiveImage extends HTMLElement {
  get intersecting() {
    return this.hasAttribute("intersecting");
  }
  constructor() {
    super();
    this.img = this.querySelector("img");
    this.src = this.img ? this.img.src : "";
    this.observerCallback = this.observerCallback.bind(this);
    if (this.img) {
      this.loadImage = this.loadImage.bind(this);
      this.img.onload = this.onLoad.bind(this);
    }
    if (this.img && this.img.complete) {
      this.onLoad();
    }
  }
  connectedCallback() {
    // Keep already loaded images sharp when their rendered slot changes.
    if (this.img && !this.hasAttribute("data-fixed-sizes") && "ResizeObserver" in window) {
      this.sizeObserver = new ResizeObserver((entries) => {
        const width = Math.round(entries[0].contentRect.width);
        const previousWidth = this.observedWidth;
        this.observedWidth = width;
        // Keep Liquid's initial responsive candidates. Adapt only when the slot
        // actually changes later (grid controls, viewport resize, variant UI).
        if (previousWidth > 0 && width > 0 && width !== previousWidth && this.intersecting) {
          this.img.sizes = width + "px";
        }
      });
      this.sizeObserver.observe(this);
    }
    if ("IntersectionObserver" in window) {
      this.initIntersectionObserver();
    } else {
      this.loadImage();
    }
  }
  disconnectedCallback() {
    this.disconnectObserver();
    this.sizeObserver?.disconnect();
  }
  loadImage() {
    this.setAttribute("intersecting", "true");
    window.MinimogEvents.emit(`m:image-loaded`, this.imageLoaded, this);
  }
  onLoad() {
    this.classList.add("m-image-loaded");
  }
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadImage();
  }
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = "10px";
    this.observer = new IntersectionObserver(this.observerCallback, { rootMargin });
    this.observer.observe(this);
  }
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}
customElements.define("responsive-image", ResponsiveImage);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      gridContainer: ".m-product-list",
      swiperWrapper: ".swiper-wrapper",
      slideControls: ".m-slider-controls",
    };

    this.enableSlider = this.dataset.enableSlider === "true";
    this.useScrollMobile = this.dataset.useScrollMobile === "true";
    this.itemsPerPage = Number(this.dataset.itemsPerPage) || 4;
    this.paginationType = this.dataset.paginationType;
  }

  connectedCallback() {
    if (this.recommendationsConnected) return;
    this.recommendationsConnected = true;
    this.hidden = false;
    const generation = this.recommendationGeneration = (this.recommendationGeneration || 0) + 1;
    this.fallbackHTML = this.querySelector("[data-kp-rec-fallback]")?.innerHTML || this.fallbackHTML || "";
    this.emptyHTML = this.querySelector("[data-kp-rec-empty]")?.innerHTML || this.emptyHTML || "";
    this.fragranceConfig = this.querySelector("[data-kp-fragrance-config]")?.textContent || this.fragranceConfig;
    this.onRecommendationScreenChange = this.onRecommendationScreenChange || (() => this.initByScreenSize());
    document.addEventListener("matchMobile", this.onRecommendationScreenChange);
    document.addEventListener("unmatchMobile", this.onRecommendationScreenChange);
    const load = () => {
      this.recommendationObserver?.disconnect();
      this.loadRecommendations(generation);
    };
    if ("IntersectionObserver" in window) {
      this.recommendationObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, { rootMargin: "0px 0px 1500px 0px" });
      this.recommendationObserver.observe(this);
    } else {
      load();
    }
  }

  disconnectedCallback() {
    this.recommendationsConnected = false;
    this.recommendationGeneration = (this.recommendationGeneration || 0) + 1;
    this.recommendationRequest?.abort();
    clearTimeout(this.recommendationTimeout);
    this.recommendationObserver?.disconnect();
    this.reservationObserver?.disconnect();
    window.removeEventListener("scroll", this.onReservationScroll);
    document.removeEventListener("matchMobile", this.onRecommendationScreenChange);
    document.removeEventListener("unmatchMobile", this.onRecommendationScreenChange);
    if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(true, true);
    this.swiper = this.slider = null;
  }

  async loadRecommendations(generation) {
    if (this.loadingGeneration === generation) return;
    this.loadingGeneration = generation;
    const current = () => this.recommendationsConnected && this.recommendationGeneration === generation;
    const controller = new AbortController();
    this.recommendationRequest = controller;
    // This covers the primary response and optional fragrance request together.
    this.recommendationTimeout = setTimeout(() => controller.abort(), 12000);
    this.setAttribute("aria-busy", "true");
    const url = this.dataset.team
      ? `${Shopify.routes.root}search?type=product&options[unavailable_products]=hide&q=${encodeURIComponent('tag:"' + this.dataset.team + '"')}&section_id=kp-team-recommendations`
      : this.dataset.url;
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error("Recommendations unavailable");
      let html = generateDomFromString(await response.text());
      if (!current()) return;
      if (this.fragranceConfig) html = await this.rankFragranceRecommendations(html, this.fallbackHTML, controller.signal);
      if (!current()) return;
      this.renderRecommendations(html.querySelector("product-recommendations"));
    } catch (error) {
      if (!current()) return;
      // Never leave an infinite skeleton, or discard the market/identity-filtered fallback.
      try {
        let html = generateDomFromString('<product-recommendations>' + this.fallbackHTML + '</product-recommendations>');
        if (this.fragranceConfig) html = await this.rankFragranceRecommendations(html, this.fallbackHTML, controller.signal, false);
        if (current()) this.renderRecommendations(html.querySelector("product-recommendations"));
      } catch (fallbackError) {
        if (!current()) return;
        this.holdRecommendationSpace();
        try { this.innerHTML = this.emptyHTML; } catch (replacementError) { /* Preserve the existing DOM. */ }
        // Keep the original verified source available if replacement/initialization itself failed.
        this.closest(".shopify-section")?.querySelector('[data-kp-merge-into-recommendations][hidden]')?.removeAttribute("hidden");
      }
    } finally {
      if (current()) {
        clearTimeout(this.recommendationTimeout);
        this.recommendationRequest = null;
        this.removeAttribute("aria-busy");
        this.finishRecommendationSpace();
      }
    }
  }

  renderRecommendations(recommendations) {
    if (this.dataset.team && recommendations) {
      recommendations.querySelectorAll('[data-team-product-id]').forEach(card => {
        if (card.dataset.teamProductId === this.dataset.productId) card.remove();
      });
    }
    this.holdRecommendationSpace();
    if (recommendations?.querySelector(".m-product-card")) {
      this.innerHTML = recommendations.innerHTML;
    } else if (this.fallbackHTML.trim() && !this.fragranceConfig) {
      this.innerHTML = this.fallbackHTML;
    } else {
      // A fragrance may have verified cards but no generic grid after strict filtering.
      const verified = this.closest(".shopify-section")?.querySelector('[data-kp-merge-into-recommendations]');
      this.innerHTML = verified?.querySelector(".m-product-card") ? verified.innerHTML : this.emptyHTML;
    }
    this.totalProducts = this.querySelectorAll(".m-product-card").length;
    this.dataset.kpRecOverflow = String(this.totalProducts > 2);
    this.initByScreenSize();
    this.removeMergedVerifiedSources();
  }

  holdRecommendationSpace() {
    if (!this.hasAttribute("data-kp-rec-reserve")) return;
    // The server-rendered skeleton already owns this space before the first paint.
    // Preserve it through replacement, including a shorter/empty/error response.
    const height = Math.ceil(this.getBoundingClientRect().height);
    if (height) this.style.minHeight = height + "px";
  }

  finishRecommendationSpace() {
    if (!this.hasAttribute("data-kp-rec-reserve")) return;
    this.dataset.kpRecState = this.querySelector(".m-product-card") ? "ready" : "empty";
    const release = () => {
      // Removing space above or inside the viewport would move the shopper's content.
      if (this.getBoundingClientRect().top < window.innerHeight) return;
      this.style.minHeight = "";
      if (this.dataset.kpRecState === "empty") this.hidden = true;
      this.reservationObserver?.disconnect();
      window.removeEventListener("scroll", this.onReservationScroll);
    };
    this.reservationObserver?.disconnect();
    window.removeEventListener("scroll", this.onReservationScroll);
    if ("IntersectionObserver" in window) {
      this.reservationObserver = new IntersectionObserver(release);
      this.reservationObserver.observe(this);
    } else {
      this.onReservationScroll = release;
      window.addEventListener("scroll", release, { passive: true });
    }
    release();
  }

  removeMergedVerifiedSources() {
    const grid = this.querySelector(".m-mixed-layout__inner");
    const section = this.closest(".shopify-section");
    if (!grid || !section) return;
    const mergedIds = new Set(
      [...grid.querySelectorAll("[data-kp-similar-product]")]
        .filter(card => card.querySelector(".m-product-card"))
        .map(card => card.dataset.kpSimilarProduct)
    );
    section.querySelectorAll("[data-kp-merge-into-recommendations][hidden]").forEach(source => {
      const cards = [...source.querySelectorAll("[data-kp-similar-product]")];
      // Keep the crawlable failure source until every verified card is in the initialized rail.
      if (cards.length && cards.every(card => card.dataset.kpSimilarProduct && mergedIds.has(card.dataset.kpSimilarProduct))) {
        source.remove();
      }
    });
  }

  async rankFragranceRecommendations(html, fallbackHTML, signal, fetchBrand = true) {
    const config = JSON.parse(this.fragranceConfig || this.querySelector('[data-kp-fragrance-config]').textContent);
    const fallback = generateDomFromString('<product-recommendations>' + fallbackHTML + '</product-recommendations>');
    let target = html.querySelector('product-recommendations');
    if (!target?.querySelector('.m-mixed-layout__inner')) {
      html = fallback;
      target = html.querySelector('product-recommendations');
    }
    const grid = target?.querySelector('.m-mixed-layout__inner');
    if (!grid) return html;
    let brandCards = [];
    try {
      const url = new URL(config.collection, location.origin);
      url.searchParams.set('filter.p.vendor', config.vendor);
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.set('section_id', 'kp-fragrance-brand-recommendations');
      if (!fetchBrand) throw new Error("Use existing fragrance pools");
      const response = await fetch(url, { signal });
      if (!response.ok) throw new Error('Brand candidates unavailable');
      const brandHTML = generateDomFromString(await response.text());
      brandCards = [...brandHTML.querySelectorAll('[data-kp-fragrance-candidate]')];
    } catch (error) {
      // Existing filtered recommendation pools remain usable if the brand request fails.
    }
    const pool = [...brandCards, ...target.querySelectorAll('[data-kp-fragrance-candidate]'), ...fallback.querySelectorAll('[data-kp-fragrance-candidate]')];
    const eligible = pool.filter(card => {
      const data = card.dataset;
      return data.gender === config.gender && data.kind === config.kind && !config.excluded.includes(data.id);
    });
    eligible.sort((a, b) => {
      const brandA = a.dataset.vendor === config.vendor ? 0 : 1;
      const brandB = b.dataset.vendor === config.vendor ? 0 : 1;
      return brandA - brandB || Math.abs(Number(a.dataset.price) - config.price) - Math.abs(Number(b.dataset.price) - config.price);
    });
    const ids = new Set(config.excluded);
    // Perfumes already shown as verified "If you like this scent" matches are not repeated below them.
    document.querySelectorAll('[data-kp-similar-product]').forEach(el => ids.add(el.dataset.kpSimilarProduct));
    const stems = new Set([config.stem]);
    const chosen = [];
    for (const card of eligible) {
      const data = card.dataset;
      if (ids.has(data.id) || (data.stem && stems.has(data.stem))) continue;
      // Cross-brand alternatives should stay within half to twice the viewed price.
      if (data.vendor !== config.vendor && (Number(data.price) < config.price * 0.5 || Number(data.price) > config.price * 2)) continue;
      ids.add(data.id);
      if (data.stem) stems.add(data.stem);
      chosen.push(card);
      if (chosen.length >= config.limit) break;
    }
    // Verified cards still lead the row when this element reconnects after its hidden source was removed.
    const sourceCards = [...(this.closest('.shopify-section')?.querySelectorAll('[data-kp-merge-into-recommendations] [data-kp-similar-product]') || [])];
    const verifiedCards = sourceCards.length ? sourceCards : [...(this.querySelector('.m-mixed-layout__inner')?.querySelectorAll('[data-kp-similar-product]') || [])];
    const verifiedIds = new Set();
    const similarCards = verifiedCards.filter(card => {
      const id = card.dataset.kpSimilarProduct;
      if (!id || verifiedIds.has(id)) return false;
      verifiedIds.add(id);
      return true;
    }).map(card => { const copy = card.cloneNode(true); copy.classList.add('swiper-slide'); return copy; });
    const merged = [...similarCards, ...chosen].slice(0, Math.max(Number(config.limit) || 8, similarCards.length));
    grid.replaceChildren(...merged);
    // Avoid restoring an irrelevant fallback after strict filtering returns nothing.
    if (!merged.length) this.querySelector('[data-kp-rec-fallback]')?.remove();
    return html;
  }

  initByScreenSize() {
    const { gridContainer, slideControls } = queryDomNodes(this.selectors, this);
    if (!gridContainer) return;

    if (MinimogTheme.config.mqlMobile && this.useScrollMobile) {
      if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(true, true);
      this.swiper = this.slider = null;
      gridContainer && gridContainer.classList.remove("swiper-container");
      slideControls && slideControls.classList.add("m:hidden");
      gridContainer && gridContainer.parentNode.classList.add("m-mixed-layout--mobile-scroll");
      if (gridContainer) {
        gridContainer.querySelectorAll(".swiper-slide").forEach(function (slide) {
          slide.style.width = "";
          slide.style.marginRight = "";
        });
        var inner = gridContainer.querySelector(".m-mixed-layout__inner");
        if (inner) {
          inner.classList.remove("swiper-wrapper");
          inner.style.transform = "";
        }
      }
    } else {
      gridContainer && gridContainer.parentNode.classList.remove("m-mixed-layout--mobile-scroll");
      this.initSlider();
    }
  }

  initSlider() {
    const __this = this;
    const { gridContainer, slideControls } = queryDomNodes(this.selectors, this);
    if (!gridContainer) return;
    const innerContainer = gridContainer.querySelector(".m-mixed-layout__inner");
    // A set that fits the desktop columns can still overflow the tablet columns.
    // Keep one responsive instance; Swiper locks controls when every card fits.
    if (this.enableSlider && this.totalProducts > 1) {
      if (typeof window.MinimogLibs?.Swiper !== "function") return;
      gridContainer.classList.add("swiper-container");
      innerContainer && innerContainer.classList.add("swiper-wrapper");
      if (this.swiper && !this.swiper.destroyed) {
        if (this.swiper.el === gridContainer) {
          this.swiper.update();
          this.syncSliderControls(this.swiper);
          return;
        }
        this.swiper.destroy(true, true);
        this.swiper = this.slider = null;
      }
      this.slider = new MinimogLibs.Swiper(gridContainer, {
        slidesPerView: this.itemsPerPage >= 2 ? 2 : 1,
        // A finite recommendation rail avoids cloning complete product-card DOM.
        loop: false,
        watchOverflow: true,
        autoplay: false,
        navigation: {
          prevEl: this.querySelector(".m-slider-controls__button-prev"),
          nextEl: this.querySelector(".m-slider-controls__button-next"),
        },
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          type: this.paginationType,
        },
        threshold: 2,
        breakpoints: {
          768: {
            slidesPerView: Math.max(1, this.itemsPerPage - 1),
          },
          1280: {
            slidesPerView: this.itemsPerPage,
          },
        },
        on: {
          init: function () {
            __this.syncSliderControls(this);
            setTimeout(() => {
              __this.syncSliderControls(this);
            }, 200);
          },
          resize: function () { __this.syncSliderControls(this); },
          lock: function () { __this.syncSliderControls(this); },
          unlock: function () { __this.syncSliderControls(this); },
        },
      });

      this.swiper = this.slider;
    } else {
      if (this.swiper && !this.swiper.destroyed) this.swiper.destroy(true, true);
      this.swiper = this.slider = null;
      innerContainer && innerContainer.classList.remove("swiper-wrapper");
      slideControls && slideControls.classList.add("m:hidden");
      gridContainer && gridContainer.classList.remove("swiper-container");
    }
  }

  syncSliderControls(swiper) {
    if (!swiper || swiper.destroyed) return;
    const { slideControls } = queryDomNodes(this.selectors, this);
    if (!slideControls) return;
    slideControls.classList.toggle("m:hidden", swiper.isLocked);
    const firstItem = this.querySelector(".m-image") || this.querySelector(".m-placeholder-svg");
    if (firstItem) slideControls.style.setProperty("--offset-top", firstItem.clientHeight / 2 + "px");
    slideControls.querySelectorAll(".m-slider-controls__button").forEach(button => button.classList.remove("m:hidden"));
  }
}
customElements.define("product-recommendations", ProductRecommendations);

if (!customElements.get("video-component")) {
  customElements.define(
    "video-component",
    class VideoComponent extends HTMLElement {
      constructor() {
        super();
        MinimogTheme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 0,
        });
      }

      init() {
        this.autoPlay = this.dataset.autoPlay === "true";
        this.muted = this.dataset.muted === "true";
        const poster = this.querySelector('[id^="Video-Deferred-Poster-"]');
        if (this.autoPlay) {
          this.loadContent();
        } else {
          poster && poster.addEventListener("click", this.loadContent.bind(this));
        }
      }

      loadContent() {
        if (!this.getAttribute("loaded")) {
          const content = document.createElement("div");
          const templateContent = this.querySelector("template")?.content?.firstElementChild;
          if (!templateContent) return;
          content.appendChild(templateContent.cloneNode(true));

          this.setAttribute("loaded", true);
          const media = content.querySelector("video, model-viewer, iframe");
          if (!media) return;
          const deferredElement = this.appendChild(media);
          this.deferredElement = deferredElement;

          if (this.autoPlay) return;

          if (this.deferredElement.classList.contains("js-youtube")) {
            const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            this.deferredElement.src += symbol + `autoplay=1${this.muted ? "&mute=1" : ""}`;
          } else if (this.deferredElement.classList.contains("js-vimeo")) {
            const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            this.deferredElement.src += symbol + `autoplay=1${this.muted ? "&mute=1" : ""}`;
          } else {
            this.deferredElement.play?.()?.catch?.(() => {});
          }
        }
      }
    }
  );
}

if (!customElements.get("collapsible-tab")) {
  class CollapsibleTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.parentEl = this.closest("[data-section-id]");
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      const destroy = this.dataset.destroy === "true";
      if (destroy) return;

      this.setDefaultData();
      this.attachEvents();

      if (this.getAttribute("open") === "true") {
        this.selected = true;
        this.classList.add(this.expandedClass);
        this.setExpandedAria();
        this.fire("tabOpened");
        window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this);
      } else {
        this.content.style.height = this.collapsedHeight;
        this.classList.add(this.collapsedClass);
        this.setCollapsedAria();
      }
      this.content.removeAttribute("hidden");
    }

    transitionendEventName() {
      let i,
        el = document.createElement("div"),
        transitions = {
          transition: "transitionend",
          OTransition: "otransitionend",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        };

      for (i in transitions) {
        if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
          return transitions[i];
        }
      }
    }

    expand() {
      const resetHeight = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (!this.isOpen) return;

        requestAnimationFrame(() => {
          this.content.style.transition = "0";
          this.content.style.height = "auto";

          requestAnimationFrame(() => {
            this.content.style.height = null;
            this.content.style.transition = null;

            this.setExpandedAria();
            this.classList.add(this.expandedClass);
            this.trySetTabIndex(this.content, 0);

            this.fire("tabOpened");
            window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this);
          });
        });
      };

      const bindEvent = resetHeight.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = true;
      this.classList.remove(this.collapsedClass);
      this.content.style.height = this.content.scrollHeight + "px";
    }

    collapse() {
      const endTransition = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (this.isOpen) return;

        this.fire("elementClosed");
        window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_CLOSED`, this);
        this.setCollapsedAria();
        this.classList.add(this.collapsedClass);
        this.trySetTabIndex(this.content, -1);
      };

      const bindEvent = endTransition.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = false;
      this.classList.remove(this.expandedClass);

      requestAnimationFrame(() => {
        this.content.style.transition = "0";
        this.content.style.height = this.content.scrollHeight + "px";

        requestAnimationFrame(() => {
          this.content.style.transition = null;
          this.content.style.height = this.collapsedHeight;
        });
      });
    }

    open() {
      this.selected = true;
      this.fire("elementSelected");
      window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_SELECTED`, this);
      this.expand();
      this.setAttribute("open", true);
    }

    close() {
      this.selected = false;
      this.fire("elementUnselected");
      window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_UNSELECTED`, this);
      this.collapse();
      this.removeAttribute("open");
    }

    toggle(event) {
      if (event) {
        event.preventDefault();
      }
      if (this.selected) {
        this.close();
      } else {
        this.open();

        if (this.oneAtATime) {
          const allItems = this.parentEl.querySelectorAll("collapsible-tab");
          const parent = this.closest("[data-first-level]");
          if (allItems.length) {
            allItems.forEach((item) => {
              if (item !== this && item.selected && parent !== item) {
                item.close();
              }
            });
          }
        }
      }
    }

    trySetTabIndex(el, index) {
      const tappableElements = el.querySelectorAll(this.defaultElements);
      if (tappableElements) {
        tappableElements.forEach((e) => {
          e.setAttribute("tabindex", index);
        });
      }
    }

    setExpandedAria() {
      this.trigger.setAttribute("aria-expanded", "true");
      this.content.setAttribute("aria-hidden", "false");
    }

    setCollapsedAria(el) {
      this.trigger.setAttribute("aria-expanded", "false");
      this.content.setAttribute("aria-hidden", "true");
    }

    attachEvents() {
      if (!this.trigger) return;
      // Stable reference so destroy() can actually unbind; re-adding the same one is a no-op.
      this.onTriggerClick = this.onTriggerClick || ((event) => this.toggle(event));
      this.trigger.addEventListener("click", this.onTriggerClick);
    }

    setDefaultData() {
      this.events = {
        elementSelected: [],
        tabOpened: [],
        elementUnselected: [],
        elementClosed: [],
      };
      this.transitionendevent = this.transitionendEventName();
      this.expandedClass = "is-expanded";
      this.collapsedClass = "is-collapsed";
      this.trigger = this.querySelector("[data-trigger]");
      this.content = this.querySelector("[data-content]");
      this.collapsedHeight = "0px";
      this.defaultElements = ["a", "button", "input:not(.focus-none)", "[data-trigger]"];
      this.oneAtATime = true;
      if (this.dataset.oneOpen) {
        this.oneAtATime = this.dataset.oneOpen === "true";
      }
    }

    fire(eventName) {
      let callbacks = this.events[eventName];
      if (callbacks) {
        for (let i = 0; i < callbacks.length; i++) {
          callbacks[i](this);
        }
      }
    }

    on(eventName, cb) {
      if (!this.events[eventName]) return;
      this.events[eventName].push(cb);
    }

    destroy() {
      if (this.trigger && this.onTriggerClick) this.trigger.removeEventListener("click", this.onTriggerClick);
      if (this.content) {
        this.content.removeAttribute("aria-hidden");
        this.content.style.height = "auto";
      }
      this.classList.remove(this.expandedClass, this.collapsedClass);
      this.removeAttribute("open");
    }
  }

  customElements.define("collapsible-tab", CollapsibleTab);
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".m-product-form-message",
          customFields: ["[data-product-custom-field]"],
          dynamicCheckout: ".m-product-dynamic-checkout",
        };
      }
      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        this.form = this.domNodes.form;
        this.productInfo = this.closest(".m-main-product--info");
        this.submitButton = this.domNodes.submitButton;
        if (!this.form || !this.domNodes.inputId) return;
        this.domNodes.inputId.disabled = false;
        this.cart = document.querySelector("m-cart-drawer");
        this.cartPage = document.querySelector("m-cart");
        this.customFields = document.querySelectorAll(this.selectors.customFields);
        if (this.domNodes.dynamicCheckout) this.enable_dynamic_checkout = true;
        if (!this.submitHandler) this.submitHandler = this.onSubmitHandler.bind(this);
        this.form.removeEventListener("submit", this.submitHandler);
        this.form.addEventListener("submit", this.submitHandler);
        this.checkoutListenerController?.abort();
        this.checkoutListenerController = new AbortController();
        if (this.domNodes.dynamicCheckout && this.customFields) {
          this.domNodes.dynamicCheckout.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.form.closest(".m-main-product--info"));
              if (missing && missing.length > 0) {
                e.stopPropagation();
                this.notify({
                  target: this.domNodes.errorWrapper,
                  method: "appendChild",
                  type: "warning",
                  message: window.MinimogStrings.requiredField,
                  delay: 100,
                });
                console.warn("Missing field(s): ", missing);
              }
            },
            { capture: true, signal: this.checkoutListenerController.signal }
          );
        }
      }
      disconnectedCallback() {
        this.checkoutListenerController?.abort();
        this.form?.removeEventListener('submit', this.submitHandler);
        this.clearFallbackNotification();
      }
      clearFallbackNotification() {
        this.fallbackNotification?.remove();
        this.fallbackNotification = null;
      }
      notify(options) {
        this.clearFallbackNotification();
        const notification = window.MinimogTheme?.Notification;
        if (typeof notification?.show === 'function') return notification.show(options);
        if (options.type === 'success' || !options.target) return;
        // vendor.js supplies the enhanced notification. Keep form errors readable if it is blocked.
        const message = document.createElement('p');
        message.setAttribute('role', 'alert');
        message.textContent = options.message;
        message.dataset.kpFormError = '';
        this.fallbackNotification = message;
        options.target.appendChild(message);
      }
      toggleSpinner(show) {
        const method = show ? "add" : "remove";
        this.classList[method]("m-spinner-loading");
      }
      getFormData() {
        const formData = new FormData(this.form);
        if (this.closest("sticky-atc")) {
          const form = document.querySelector(".m-main-product--info .m-product-form--main form");
          const extraFormData = form ? new FormData(form) : new FormData();

          for (const [key, value] of extraFormData.entries()) {
            if (!formData.has(key)) {
              formData.set(key, value);
            }
          }
        }

        return formData;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // The add goes by fetch, so nothing above the form needs this submit. Google's tag
        // (gtag.js) keeps a document-level submit listener that scanned the form for 28-51 ms
        // inside every Add to basket tap on a phone (17 Oct 2026); stopping here skips it.
        evt.stopPropagation();
        if (this.submitting) return;
        this.clearFallbackNotification();
        this.submitting = true;
        this.setAttribute("aria-busy", "true");
        this.toggleSpinner(true);
        const missing = validateForm(this.form.closest(".m-main-product--info"));

        if (missing && missing.length > 0) {
          console.warn("Missing field(s): ", missing);
          this.toggleSpinner(false);
          this.submitting = false;
          this.removeAttribute("aria-busy");
          return this.notify({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.MinimogStrings.requiredField,
          });
        }

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = this.getFormData();
        formData.append("sections", [...new Set(sectionsToBundle)]);
        formData.append("sections_url", window.location.pathname);

        config.body = formData;

        const { MinimogSettings, MinimogStrings } = window;
        const kpAdd = { source: window.KPTheme?.source(this), variant_id: formData.get('id'), quantity: Number(formData.get('quantity') || 1) };
        let kpAdded = false;
        window.KPTheme?.track('cart_add_attempt', kpAdd);
        fetch(`${MinimogSettings.routes.cart_add_url.replace(/(?:\.js)?$/, ".js")}`, config)
          .then((response) => response.json())
          .then((response) => {
            // Handle Error
            if (response.status) {
              window.KPTheme?.track('cart_add_failure', { ...kpAdd, status: response.status });
              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.error || response.description,
                message: response.message,
              });
              document.dispatchEvent(
                new CustomEvent("product-ajax:error", {
                  detail: {
                    errorMessage: response.error || response.description,
                  },
                })
              );
              this.error = true;
              const variantId = formData.get("id");
              if (variantId === "" || variantId === null) {
                this.handleErrorMessageVariantPicker();
                return this.notify({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "error",
                  message: MinimogStrings.selectVariant,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              } else {
                return this.notify({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "error",
                  message: response.message,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              }
            }

            kpAdded = true;
            window.KPTheme?.added(response, kpAdd);
            if (MinimogSettings.use_ajax_atc) {
              // Handle Ajax ATC
              if (this.cart && typeof this.cart.open === 'function' && MinimogSettings.enable_cart_drawer) {
                this.notify({
                  target: this.cart.querySelector("m-cart-items"),
                  method: "prepend",
                  type: "success",
                  message: MinimogStrings.itemAdded,
                  delay: 400,
                });
                // Open cart drawer
                this.cart.open();
              } else {
                if (MinimogSettings.enable_cart_drawer) {
                  // cart.js did not upgrade the drawer: the successful add is still usable on /cart.
                  window.location.href = MinimogSettings.routes.cart;
                  return;
                }
                this.notify({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "success",
                  message: MinimogStrings.itemAdded,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              }

              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
                cart: response,
                productVariantId: formData.get("id"),
              });

              // dispatch product added event
              document.dispatchEvent(
                new CustomEvent("product-ajax:added", {
                  detail: {
                    product: response,
                  },
                })
              );

              this.error = false;
            } else {
              window.location = MinimogSettings.routes.cart;
            }
          })
          .catch((e) => {
            if (!kpAdded) {
              window.KPTheme?.track('cart_add_failure', { ...kpAdd, reason: 'request_failed' });
              // Offline, 429 or an HTML 5xx page: the spinner stopped and nothing was added. Say so.
              this.notify({
                target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                method: "appendChild",
                type: "error",
                message: MinimogStrings.cartError,
                last: 3000,
                sticky: !this.domNodes.errorWrapper,
              });
            }
            console.error(e);
          })
          .finally(() => {
            this.submitting = false;
            this.removeAttribute("aria-busy");
            this.toggleSpinner(false);
          });
      }
      handleErrorMessageVariantPicker() {
        const variantPicker = this.productInfo && this.productInfo.querySelector("variant-picker");
        const options = variantPicker && variantPicker.querySelectorAll("[data-selected-value]");

        options &&
          options.forEach((option) => {
            const value = option.dataset.selectedValue;
            if (value === "") {
              option.classList.add("m-product-option--unselect");
              setTimeout(() => {
                option.classList.remove("m-product-option--unselect");
              }, 3000);
            }
          });
      }

      get variantIdInput() {
        return this.form?.querySelector("[name=id]");
      }
    }
  );
}

if (!customElements.get("m-video-component")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();
      this.background = this.dataset.initMode !== "template";
      if (this.background) {
        MinimogTheme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 0,
        });
      } else {
        this.init();
      }
    }

    init() {
      this.parentSelector = this.dataset.parent || ".m-hero__bg";
      this.parent = this.closest(this.parentSelector);

      switch (this.dataset.type) {
        case "youtube":
          this.initYoutubeVideo();
          break;

        case "vimeo":
          this.initVimeoVideo();
          break;

        case "mp4":
          this.initMp4Video();
          break;
      }
    }

    initYoutubeVideo() {
      this.setAsLoading();
      this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this)).catch(() => this.parent?.removeAttribute("loading"));
    }

    initVimeoVideo() {
      this.setAsLoading();
      this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this)).catch(() => this.parent?.removeAttribute("loading"));
    }

    initMp4Video() {
      const player = this.querySelector("video");

      if (player) {
        const promise = player.play();

        // Edge does not return a promise (video still plays)
        if (typeof promise !== "undefined") {
          promise
            .then(function () {
              // playback normal
            })
            .catch(function () {
              player.setAttribute("controls", "");
            });
        }
      }
    }

    loadScript(videoType) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = videoType === "youtube" ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js";
      });
    }

    setAsLoading() {
      this.parent?.setAttribute("loading", true);
    }

    setAsLoaded() {
      this.parent?.removeAttribute("loading");
      this.parent?.setAttribute("loaded", true);
    }

    setupYoutubePlayer() {
      const videoId = this.dataset.videoId;
      const startedAt = Date.now();
      const playerInterval = setInterval(() => {
        if (!this.isConnected || Date.now() - startedAt >= 10000) {
          clearInterval(playerInterval);
          this.parent?.removeAttribute("loading");
          return;
        }
        if (typeof window.YT?.ready === 'function') {
          clearInterval(playerInterval);
          window.YT.ready(() => {
            if (!this.isConnected || typeof window.YT?.Player !== 'function') {
              this.parent?.removeAttribute("loading");
              return;
            }
            const element = document.createElement("div");
            this.appendChild(element);

            this.player = new YT.Player(element, {
              videoId: videoId,
              playerVars: {
                showinfo: 0,
                controls: false,
                fs: 0,
                rel: 0,
                height: "100%",
                width: "100%",
                iv_load_policy: 3,
                html5: 1,
                loop: 1,
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
              },
              events: {
                onReady: this.onYoutubeReady.bind(this),
                onStateChange: this.onYoutubeStateChange.bind(this),
              },
            });
            clearInterval(playerInterval);
          });
        }
      }, 50);
    }

    onYoutubeReady() {
      this.iframe = this.querySelector("iframe"); // iframe once YT loads
      if (!this.iframe) return;
      this.iframe.setAttribute("tabindex", "-1");
      if (typeof this.player.mute === "function") this.player.mute();
      if (typeof this.player.playVideo === "function") this.player.playVideo();

      this.setAsLoaded();

      // pause when out of view
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.youtubePlay();
              } else {
                this.youtubePause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      }
    }

    onYoutubeStateChange(event) {
      switch (event.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (this.attemptedToPlay) {
            this.setAsLoaded();
            // this.closest('.banner').classList.add('video-interactable');
          }
          break;
        case 0: // ended, loop it
          this.youtubePlay();
          break;
        case 1: // playing
          this.setAsLoaded();
          break;
        case 3: // buffering
          this.attemptedToPlay = true;
          break;
      }
    }

    youtubePlay() {
      if (this.player && typeof this.player.playVideo === "function") {
        this.player.playVideo();
      }
    }

    youtubePause() {
      if (this.player && typeof this.player.pauseVideo === "function") {
        this.player.pauseVideo();
      }
    }

    setupVimeoPlayer() {
      const videoId = this.dataset.videoId;
      const startedAt = Date.now();

      const playerInterval = setInterval(() => {
        if (!this.isConnected || Date.now() - startedAt >= 10000) {
          clearInterval(playerInterval);
          this.parent?.removeAttribute("loading");
          return;
        }
        if (typeof window.Vimeo?.Player === 'function') {
          this.player = new Vimeo.Player(this, {
            id: videoId,
            autoplay: true,
            autopause: false,
            background: false,
            controls: false,
            loop: true,
            height: "100%",
            width: "100%",
          });
          this.player.ready().then(this.onVimeoReady.bind(this)).catch(() => this.parent?.removeAttribute("loading"));
          clearInterval(playerInterval);
        }
      }, 50);
    }

    onVimeoReady() {
      this.iframe = this.querySelector("iframe");
      if (!this.iframe) return;
      this.iframe.setAttribute("tabindex", "-1");

      this.player.setMuted(true)?.catch?.(() => {});

      this.setAsLoaded();

      // pause when out of view
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.vimeoPlay();
            } else {
              this.vimeoPause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this.iframe);
    }

    vimeoPlay() {
      if (this.player && typeof this.player.play === "function") {
        this.player.play()?.catch?.(() => {});
      }
    }

    vimeoPause() {
      if (this.player && typeof this.player.pause === "function") {
        this.player.pause()?.catch?.(() => {});
      }
    }
  }
  customElements.define("m-video-component", VideoComponent);
}

if (!customElements.get("m-search-popup")) {
  class MSearchPopup extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        container: "[data-search-container]",
        form: "form",
        input: "[data-search-input]",
        submit: 'button[type="submit"]',
        loading: "[data-spinner]",
        close: "[data-close-search]",
      };

      const searchPopup = document.querySelector("[data-search-popup]");
      if (!searchPopup) return;
      // Header, header option and mobile sticky bar each render an <m-search-popup> but share this
      // one popup: bind it once, or every click opens N times and submit fires N form submissions.
      if (searchPopup.dataset.kpSearchBound === "true") return;
      searchPopup.dataset.kpSearchBound = "true";

      this.domNodes = queryDomNodes(this.selectors, searchPopup);
      this.domNodes.searchPopup = searchPopup;
      document.body.appendChild(searchPopup);
      addEventDelegate({
        selector: "[data-open-search-popup]",
        handler: () => this.openSearchPopup(),
      });

      const { input, submit, close, form } = this.domNodes;
      if (input) {
        input.addEventListener("keydown", (e) => {
          // ESC
          if (e.keyCode === 27) {
            this.closeSearchPopup();
          }
        });
      }
      submit?.addEventListener("click", (e) => {
        e.preventDefault();
        if (input && input.value && form) {
          form.submit();
        }
      });
      close?.addEventListener("click", (e) => {
        this.closeSearchPopup();
        MinimogEvents.emit(MinimogTheme.pubSubEvents.closeSearchPopup);
      });
      searchPopup.addEventListener("click", (e) => {
        if (e.target === searchPopup) {
          this.closeSearchPopup();
        }
      });

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
        if (this.hasAttribute("open")) this.closeSearchPopup();
      });
    }

    openSearchPopup() {
      const { searchPopup, input, container } = this.domNodes;
      searchPopup.style.removeProperty("visibility");
      searchPopup.style.setProperty("opacity", "1");
      container.classList.add("m-show-search");
      this.setAttribute("open", true);
      setTimeout(() => {
        container.style.removeProperty("--m-durations");
        input.focus();
      }, 350);
      document.documentElement.classList.add("prevent-scroll");
      MinimogEvents.emit(MinimogTheme.pubSubEvents.openSearchPopup, this);
    }

    closeSearchPopup() {
      const { searchPopup, container } = this.domNodes;
      container.classList.remove("m-show-search");
      searchPopup.style.setProperty("opacity", "0");
      setTimeout(() => {
        searchPopup.style.setProperty("visibility", "hidden");
        container.style.setProperty("--m-durations", ".3s");
        document.documentElement.classList.remove("prevent-scroll");
        this.removeAttribute("open");
      }, 350);
    }
  }

  customElements.define("m-search-popup", MSearchPopup);
}

if (!customElements.get("m-select-component")) {
  class MSelectComponent extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        elSelectNative: ".js-selectNative",
        elSelectCustom: ".js-selectCustom",
        elSelectCustomBox: ".m-select-custom--trigger",
        elSelectCustomOpts: ".m-select-custom--options",
        elSelectCustomTriggerText: ".m-select-custom--trigger-text",
        customOptionList: [".m-select-custom--option"],
      };

      this.optionChecked = "";
      this.onClickOutside = this.handleClickOutside.bind(this);
    }

    connectedCallback() {
      this.initComponent();
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.onClickOutside);
    }

    initComponent() {
      // Moving the element (disconnect + connect) must not bind the toggle twice:
      // two toggle handlers open and immediately close the dropdown.
      if (this._initialized) return;
      this.domNodes = queryDomNodes(this.selectors, this);
      const { elSelectNative, elSelectCustomBox } = this.domNodes;
      if (!elSelectNative || !elSelectCustomBox) {
        if (!this._retryCount) this._retryCount = 0;
        if (this._retryCount < 3) {
          this._retryCount++;
          requestAnimationFrame(() => this.initComponent());
        }
        return;
      }
      this._initialized = true;
      this.classList.remove("m:hidden");
      this.setDefaultValue();
      this.initSelect();
    }

    setDefaultValue() {
      const { elSelectNative } = this.domNodes;
      if (!elSelectNative || !elSelectNative.options || elSelectNative.selectedIndex < 0) return;
      const selectedOption = elSelectNative.options[elSelectNative.selectedIndex];
      if (!selectedOption) return;
      const value = selectedOption.value;
      const text = selectedOption.text;
      this.updateCustomSelectChecked(value, text);
    }

    initSelect() {
      this.classList.remove("m:hidden");
      const { elSelectNative, elSelectCustom, elSelectCustomBox } = this.domNodes;
      if (!elSelectCustomBox || !elSelectCustom) return;

      if (elSelectNative) elSelectNative.addEventListener("change", () => {
        const opt = elSelectNative.options[elSelectNative.selectedIndex];
        if (opt && opt.value !== this.optionChecked) this.updateCustomSelectChecked(opt.value, opt.text);
      });

      elSelectCustomBox.addEventListener("click", () => {
        const isClose = !elSelectCustom.classList.contains("isActive");
        if (isClose) {
          this.openSelect();
        } else {
          this.closeSelect();
        }
      });

      if (Array.isArray(this.domNodes.customOptionList)) {
        this.domNodes.customOptionList.forEach((option) => {
          option.addEventListener("click", (e) => {
            const value = e.target.getAttribute("data-value");
            if (elSelectNative) {
              elSelectNative.value = value;
              elSelectNative.dispatchEvent(new Event("change"));
              elSelectNative.dispatchEvent(new Event("click"));
            }
            this.closeSelect();
            this.updateCustomSelectChecked(value, e.target.textContent);
          });
        });
      }
    }

    openSelect() {
      const allCustomSelect = document.querySelectorAll("m-select-component");
      // One stable reference: re-adding it on every open is a no-op instead of a leak.
      document.addEventListener("click", this.onClickOutside);
      if (allCustomSelect.length > 0) {
        allCustomSelect.forEach((select) => {
          if (select !== this && typeof select.closeSelect === "function") {
            select.closeSelect();
          }
        });
      }
      if (this.domNodes && this.domNodes.elSelectCustom) {
        this.domNodes.elSelectCustom.classList.add("isActive");
      }
    }

    closeSelect() {
      document.removeEventListener("click", this.onClickOutside);
      if (this.domNodes && this.domNodes.elSelectCustom) {
        this.domNodes.elSelectCustom.classList.remove("isActive");
      }
    }

    updateCustomSelectChecked(value, text) {
      if (!this.domNodes) return;
      const { elSelectCustomOpts, elSelectCustomTriggerText } = this.domNodes;
      if (!elSelectCustomOpts || !elSelectCustomTriggerText) return;
      const prevValue = this.optionChecked;
      const escapeValue = (v) => (window.CSS && CSS.escape ? CSS.escape(String(v)) : String(v).replace(/["\\]/g, "\\$&"));
      const elPrevOption = elSelectCustomOpts.querySelector(`[data-value="${escapeValue(prevValue)}"]`);

      const elOption = elSelectCustomOpts.querySelector(`[data-value="${escapeValue(value)}"]`);

      if (elPrevOption) {
        elPrevOption.classList.remove("isActive");
      }

      if (elOption) {
        elOption.classList.add("isActive");
      }

      elSelectCustomTriggerText.textContent = text;
      this.optionChecked = value;
    }

    handleClickOutside(e) {
      const elSelectCustom = this.domNodes && this.domNodes.elSelectCustom;
      if (!elSelectCustom) return;
      const didClickedOutside = !elSelectCustom.contains(e.target);
      if (didClickedOutside) {
        this.closeSelect();
      }
    }
  }

  customElements.define("m-select-component", MSelectComponent);
}

class MQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.quantityUpdateUnsubscriber = undefined;
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  get productId() {
    return this.getAttribute("data-product-id");
  }

  get input() {
    return this.querySelector("input");
  }

  get value() {
    return this.input.value;
  }

  connectedCallback() {
    this.changeEvent = new Event("change", { bubbles: true });
    if (!this.input) return;

    // The cart drawer replaces these inputs on every change. Tie every listener to this
    // connection so detached inputs are released and a re-connect cannot double-step.
    this.listenerController?.abort();
    this.listenerController = new AbortController();
    const { signal } = this.listenerController;

    this.input.addEventListener("change", this.onInputChange.bind(this), { signal });
    this.input.addEventListener("focus", () => setTimeout(() => this.input && this.input.select()), { signal });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this), { signal })
    );

    this.validateQtyRules();
    this.quantityUpdateUnsubscriber?.();
    this.quantityUpdateUnsubscriber = MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.quantityUpdate,
      this.validateQtyRules.bind(this)
    );

    // Sync 2 inputs inside product info and sticky ATC
    this.shouldSync = this.closest(".m-main-product--info") || this.closest("sticky-atc");
    if (this.shouldSync) {
      window.addEventListener("syncProductQuantity", (event) => {
        if (this.input && event.detail !== this.input.value) {
          this.input.value = event.detail;
          this.validateQtyRules();
        }
      }, { signal });
    }
  }

  disconnectedCallback() {
    this.listenerController?.abort();
    this.listenerController = undefined;
    this.quantityUpdateUnsubscriber?.();
    this.quantityUpdateUnsubscriber = undefined;
  }
  onInputChange() {
    if (this.shouldSync) {
      window.dispatchEvent(new CustomEvent("syncProductQuantity", { detail: this.input.value }));
    }

    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.disabled) return;
    const previousValue = this.input.value;
    const increase = event.currentTarget.name === "plus";
    const allowRemove = this.hasAttribute("data-allow-remove");

    // Cart minus can remove a line without changing the native keyboard step base.
    if (allowRemove && !increase && Number(previousValue) <= Number(this.input.min)) {
      this.input.value = "0";
    } else if (allowRemove && increase && Number(previousValue) === 0) {
      this.input.value = this.input.min;
    } else if (increase) {
      if (parseInt(this.input.getAttribute("data-min")) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.getAttribute("data-min");
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.getAttribute("data-min") === previousValue && event.currentTarget.name === "minus") {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const buttonMinus = this.querySelector(".m-quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".m-quantity__button[name='plus']");

    const minusDisabled = this.input.disabled || (this.hasAttribute("data-allow-remove")
      ? value <= 0
      : Boolean(this.input.min && value <= parseInt(this.input.min)));
    const plusDisabled = this.input.disabled || Boolean(this.input.max && value >= parseInt(this.input.max));
    buttonMinus.disabled = minusDisabled;
    buttonPlus.disabled = plusDisabled;
    buttonMinus.setAttribute("aria-disabled", String(minusDisabled));
    buttonPlus.setAttribute("aria-disabled", String(plusDisabled));
    buttonMinus.classList.toggle("m:disabled", minusDisabled);
    buttonPlus.classList.toggle("m:disabled", plusDisabled);
  }

  updateQuantityRules(sectionId, productId, parsedHTML) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const selectors = [".m-quantity__input", ".quantity__rules", ".m-product-option--label"];
    const quantityFormUpdated = parsedHTML.getElementById(`QuantityForm-${sectionId}`);
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
    if (!quantityFormUpdated) return;
    for (let selector of selectors) {
      // Sticky purchase controls share the rules but sit outside the main wrapper.
      const current = selector === ".m-quantity__input" ? this.input : quantityForm?.querySelector(selector);
      const updated = quantityFormUpdated.querySelector(selector);
      if (!current || !updated) continue;

      if (selector === ".m-quantity__input") {
        const attributes = ["data-cart-quantity", "data-min", "data-max", "step"];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }

  setQuantityBoundries(sectionId, productId) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    if (!this.input) return;

    const data = {
      cartQuantity: this.input.hasAttribute("data-cart-quantity")
        ? parseInt(this.input.getAttribute("data-cart-quantity"))
        : 0,
      min:
        this.input.hasAttribute("data-min") && this.input.getAttribute("data-min")
          ? parseInt(this.input.getAttribute("data-min"))
          : 1,
      max:
        this.input.hasAttribute("data-max") && this.input.getAttribute("data-max")
          ? parseInt(this.input.getAttribute("data-max"))
          : null,
      step:
        this.input.hasAttribute("step") && this.input.getAttribute("step")
          ? parseInt(this.input.getAttribute("step"))
          : 1,
    };

    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

    this.input.min = min;

    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute("max");
    }
    this.input.value = min;

    MinimogEvents.emit(MinimogTheme.pubSubEvents.quantityUpdate, undefined);
  }

  reset() {
    this.input.value = this.input.defaultValue;
  }

  setValidity(message) {
    this.input.setCustomValidity(message);
    this.input.reportValidity();
    this.input.value = this.input.defaultValue;
    this.input.select();
    // Avoid the button being disabled when enter a value is greater than max value or less than min value
    this.validateQtyRules();
  }
}

customElements.define("m-quantity-input", MQuantityInput);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // Storage can be blocked, corrupt, or become unavailable between operations.
    try {
      if (isStorageSupported("local")) {
        const productId = Number(this.dataset.productId);
        if (!Number.isFinite(productId) || productId <= 0) return;
        const cookieName = "minimog-recently-viewed";
        const saved = JSON.parse(window.localStorage.getItem(cookieName) || "[]");
        const items = Array.isArray(saved) ? saved.filter(Number.isFinite) : [];
        if (!items.includes(productId)) items.unshift(productId);
        window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
      }
    } catch (_) {
      // Recently viewed is optional; its storage must not break product controls.
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    if (this.hasAttribute("style")) return;

    if (this.dataset.from) {
      this.initProgress();
    }

    MinimogTheme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    this.setPercentage(this.dataset.value, this.dataset.max);
  }

  initProgress() {
    this.setPercentage(this.dataset.from, this.dataset.max);
  }

  setPercentage(val1, val2) {
    this.style.setProperty("--percent", `${(parseInt(val1) / parseInt(val2)) * 100}%`);
  }
}
customElements.define("progress-bar", ProgressBar);

if (!customElements.get("m-cart-count")) {
  class MCartCount extends HTMLElement {
    constructor() {
      super();
      this.getSectionToRenderListener = this.getSectionToRender.bind(this);
      this.cartUpdateUnsubscriber = undefined;
    }

    get sectionName() {
      return "cart-count";
    }

    getSectionToRender(event) {
      event.detail.sections.push(this.sectionName);
    }

    connectedCallback() {
      document.addEventListener("cart:grouped-sections", this.getSectionToRenderListener);

      this.cartUpdateUnsubscriber?.();
      this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
        MinimogTheme.pubSubEvents.cartUpdate,
        this.onCartUpdate.bind(this)
      );
    }

    disconnectedCallback() {
      document.removeEventListener("cart:grouped-sections", this.getSectionToRenderListener);
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    get itemCount() {
      return parseInt(this.innerText);
    }

    onCartUpdate(event) {
      if (event.cart.errors || !event.cart.sections?.[this.sectionName]) return;
      const sectionToRender = new DOMParser().parseFromString(event.cart.sections[this.sectionName], "text/html");
      this.onUpdate(sectionToRender);
    }

    onUpdate(section) {
      const count = section.querySelector(".m-cart-count");
      if (!count) return;
      this.innerText = count.innerText;
      const method = this.itemCount === 0 ? "add" : "remove";
      this.classList[method]("m:hidden");
    }
  }
  customElements.define("m-cart-count", MCartCount);
}

class MAccountComponent extends HTMLElement {
  async connectedCallback() {
    const account = this.querySelector("shopify-account");

    if (!account) return;

    this.injectAnimation(account);
  }

  injectAnimation(account) {
    const shadow = account.shadowRoot;

    if (!shadow || shadow.querySelector("#custom-account-styles")) return;

    const style = document.createElement("style");
    style.id = "custom-account-styles";

    style.textContent = `
      @keyframes dialogScaleIn {
        0% {
          transform: scale(0.8);
          opacity: 0;
        }
        100% {
          transform: scale(1);
          opacity: 1;
        }
      }
      @keyframes dialogScaleOut {
        0% {
          transform: scale(1);
          opacity: 1;
        }

        100% {
          transform: scale(0.8);
          opacity: 0;
        }
      }
      @keyframes dialogBackdropIn {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
      @keyframes dialogBackdropOut {
        0% {
          opacity: 1;
        }

        100% {
          opacity: 0;
        }
      }
      @media (min-width: 751px) {
        dialog .account {
          height: fit-content;
          background: #fff;
          border-radius: inherit;
        }
        dialog[open] {
          animation: dialogScaleIn 0.6s cubic-bezier(0.7, 0, 0.2, 1) !important;
        }
        dialog.closing {
          animation: dialogScaleOut 0.6s cubic-bezier(0.7, 0, 0.2, 1) !important;
        }
        dialog[open]::backdrop {
          cursor: zoom-out;
          animation: dialogBackdropIn 0.8s cubic-bezier(0.7, 0, 0.2, 1) !important;
        }
        dialog.closing::backdrop {
          animation: dialogBackdropOut 0.8s cubic-bezier(0.7, 0, 0.2, 1) !important;
        } 
      }
      @media (max-width: 750px) {
        dialog .account__content {
          padding-bottom: 2.4rem;
        }
      }
    `;

    shadow.prepend(style);
  }
}

customElements.define("m-account-component", MAccountComponent);
